import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { message } from 'antd';
import * as Yup from 'yup';
import { uploadReport, getUploadedReports } from '../../Web Apis/webApis';
import { MdOutlineFileDownload } from "react-icons/md";
import Load from "../Load/Load"

import { editCase } from '../../Web Apis/webApis'


const Report = ({ showModal, setShowModal, selectedCase, action, setAction }) => {
    const [loading, setLoading] = useState(false);
    const [reportsData, setReportsData] = useState([])

    const closeModal = () => {
        setShowModal(false);
    };


    const fileRef = useRef(null)

    const fetchReports = async () => {
        try {
            setLoading(true)

            const response = await getUploadedReports(selectedCase?.id)

            if (response?.data?.success) {
                setReportsData(response?.data?.data)
            }

        } catch (error) {
            console.log("Error while fetch relation category", error.message)
            if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                // Handle internet disconnection
                return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
                window.alert("Your account is logged in to another device, please login again !")
                localStorage.clear();
                window.location.href = "/login"
            }
            if (error?.response?.status === 500) {
                message.error("Server not responding")
            } else {
                return;
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchReports()
    }, [])





    const formik = useFormik({
        initialValues: {
            reportFiles: [],
            reportNames: []
        },
        validationSchema: Yup.object({
            reportFiles: Yup.array().min(1, "At least one report file is required"),
            reportNames: Yup.array().of(
                Yup.string().required("Report name is required").max(30, "Report name should not more than 30 characters").min(3, "Report name should be atleast 3 characters long")
            )
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                setLoading(true);
                const formData = new FormData();

                values.reportFiles.forEach((file, index) => {
                    formData.append("caseReportsFiles", file);
                    formData.append("reportNames", values.reportNames[index] || file.name);
                });

                const response = await uploadReport(selectedCase?.id, formData)
                if (response?.data?.success) {
                    message.success(response?.data?.message)
                    if(selectedCase?.status === "Completed"){
                        resetForm()
                        setAction(!action)
                        setShowModal(false)
                        return;
                    } else {
                        const status = "Completed"
                       const res =  await editCase (selectedCase?.id, status)
                        if(res?.data?.success){
                            resetForm()
                           
                            setShowModal(false)

                            setTimeout(() => {
                                setAction(!action)
                            },[200])
                          
                        }
                    }

                }


            } catch (error) {
                console.error("Error while uploading reports", error);
                message.error(error?.response?.data?.message || "Error while uploading reports");
            } finally {
                setSubmitting(false);
                setLoading(false);
            }
        }
    });

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        formik.setFieldValue("reportFiles", selectedFiles);
        formik.setFieldValue("reportNames", selectedFiles.map(file => ""));

        // fileRef.current.value = ""; // Allows re-uploading same file after removing

    };

    const handleNameChange = (index, newName) => {
        const newNames = [...formik.values.reportNames];
        newNames[index] = newName;
        formik.setFieldValue("reportNames", newNames);
    };

    const removeFile = (index) => {
        const newFiles = formik.values.reportFiles.filter((_, i) => i !== index);
        const newNames = formik.values.reportNames.filter((_, i) => i !== index);
        formik.setFieldValue("reportFiles", newFiles);
        formik.setFieldValue("reportNames", newNames);

          // ✅ If no files are left, reset the input value
    if (newFiles.length === 0 && fileRef.current) {
        fileRef.current.value = "";
    }


    if (fileRef.current) {
        fileRef.current.value = "";
    }
    };

    return (
        showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white rounded-2xl shadow-lg w-[500px] p-6 overflow-y-auto scrollbar-hidden">
                    <h3 className="text-xl font-bold mb-4 text-center bg-gradient-to-br from-teal-950 to-teal-500 py-2 text-white">
                        Upload Reports
                    </h3>
                    <form className="space-y-4" onSubmit={formik.handleSubmit}>
                        <input
                            type="file"
                            multiple
                            ref={fileRef}
                            onChange={handleFileChange}
                            className="w-full border border-gray-300 p-2 rounded-md"
                        />
                        {formik.touched.reportFiles && formik.errors.reportFiles && (
                            <p className="text-red-600">{formik.errors.reportFiles}</p>
                        )}


                        {formik?.values?.reportFiles?.length > 0 && (
                            <div className="mt-4 space-y-2">
                                {formik.values.reportFiles.map((file, index) => (
                                    <div key={index} className="flex flex-col">
                                        <div className="flex items-center gap-2">
                                            <input
                                                type="text"
                                                placeholder="Enter report name"
                                                value={formik.values.reportNames[index] || ''}
                                                onChange={(e) => handleNameChange(index, e.target.value)}
                                                className={`border p-2 flex-1 rounded-md 
                                                ${formik.errors.reportNames?.[index] && formik.touched.reportNames?.[index] ? 'border-red-500' : 'border-gray-300'}`}
                                            />

                                            <span className="text-sm text-gray-600">{file.name}</span>
                                            <button
                                                type="button"
                                                onClick={() => removeFile(index)}
                                                className="text-red-500 hover:text-red-700"
                                            >
                                                ✖
                                            </button>
                                        </div>
                                        {formik.errors.reportNames?.[index] && formik.touched.reportNames?.[index] && (
                                            <p className="text-red-600 text-sm mt-1">{formik.errors.reportNames[index]}</p>
                                        )}
                                    </div>

                                ))}



                            </div>
                        )}


                        <div className="flex justify-end gap-4 mt-6">
                            <button
                                type="button"
                                onClick={closeModal}
                                className="bg-gray-300 text-black w-24 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                className="bg-teal-500 text-white w-24 py-2 px-4 rounded-md hover:bg-teal-700 transition duration-200"
                            >
                                {formik.isSubmitting ? "Uploading..." : "Upload"}
                            </button>
                        </div>
                        {reportsData?.length > 0 && (
                            <div className="mt-6">
                                <h3 className="text-xl font-bold mb-4 text-center bg-gradient-to-br from-teal-950 to-teal-500 py-2 text-white">
                                    Uploaded Reports
                                </h3>
                                <div className="space-y-2">
                                    {reportsData.map((report, index) => (
                                        <div key={index} className="flex items-center justify-between bg-gray-100 p-2 rounded-md">
                                            <span className="text-sm text-gray-800">{report.reportName}</span>
                                            <a href={report.caseReport} download>
                                                <MdOutlineFileDownload className="text-blue-500 hover:underline cursor-pointer text-2xl" />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                    </form>
                    {loading && <Load />}
                </div>
            </div>
        )
    );
};

export default Report;
